import React, { useState } from "react";
import ExcelExportsModal from "./modal/excel.exports.modal";
import styled from "styled-components";
import OutlinedButton from "../../../../app/components/buttons/outlined";

export default function ExcelExports() {
  const [open, setOpen] = useState(false);
  return (
    <Container>
      <OutlinedButton onClick={() => setOpen(true)}>
        Export Tables
      </OutlinedButton>
      <ExcelExportsModal
        open={open}
        handleClose={() => setOpen(false)}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  // height: fit-content;
`;
